<template>
  <div>
    <div class="banner-news">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082712582772.jpg"></el-image>
      <!--      <div class="cover">-->
      <!--        <h1>公司新闻</h1>-->
      <!--        <div class="subtitle">新闻中心</div>-->
      <!--      </div>-->
    </div>
    <div class="nav">
      <div class="content8" v-if="articleClass!=null && article!=null">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ articleClass.name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ article.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="content-news" v-if="article!=null">
      <h1>{{ article.title }}</h1>
      <div class="news-detail clearfix">
        <div class="news-desc" v-html="article.content">
        </div>
        <div class="news-bottom"></div>
        <div class="btn-back" @click="goBack()">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getArticleDetail} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      article: null,
      articleClass: null,
    }
  },
  created() {
    this.getArticle();
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getArticle() {
      let id = this.$route.query.id;
      getArticleDetail(id).then((res) => {
        this.article = res.data.article;
        this.articleClass = res.data.articleClass;
      });
    }
  }
}
</script>

<style scoped>
@import url("Index.css");
</style>